import { Clip } from "@clarkinc/zest-design-system";
import React from "react";
import NoScriptLazyImage from "~/common/NoScriptLazyImage";
import { Video } from "~/common/Store/models/Video";
interface Props {
  header: string | "";
  description: string | "";
  image: string | "";
  imageHasPadding: boolean;
  video?: Video;
  loops: number | undefined;
}
const HeadlineAndContent = ({
  header,
  description,
  image,
  imageHasPadding,
  video,
  loops
}: Props) => <div className="detail-section intro-template" data-testid="introduction" data-sentry-component="HeadlineAndContent" data-sentry-source-file="HeadlineAndContent.tsx">
    {header.trim().length > 0 && <h2 className="headline" id="details-group-headline" dangerouslySetInnerHTML={{
    __html: header.trim()
  }} />}
    <div className="flex-container">
      {image && <div className={`template-image${imageHasPadding ? " exp-crop-padding" : ""}`}>
          <NoScriptLazyImage alt="" src={image} className="expanded-img expanded-large lazyLoad b-loaded" />
        </div>}
      {video && <div className="exp-crop-padding py-5">
          <Clip sources={[{
        src: `${video.videoPath}${video.sources.high}`,
        type: "video/mp4"
      }]} altText={video.title ?? ""} poster={video.poster} loops={loops} autoPlay />
        </div>}
      {description.length > 0 && <div className="template-text">
          <p dangerouslySetInnerHTML={{
        __html: description
      }} />
        </div>}
    </div>
  </div>;
export default HeadlineAndContent;